
import storage from 'good-storage';
import cookies from 'js-cookie'

const web_token = 'xpj_manager_token';//用户token
const web_user = 'xpj_manager_user';//用户信息
const web_company = 'xpj_manager_company';//当前选的公司;



export function saveCompany(value)
{
    storage.set(web_company,value);
    return value;
}
export function getCompany()
{
    return storage.get(web_company,null);
}
export function removeCompany(value)
{
    storage.remove(web_company);
}

//修改用户信息
export function setLocalUser(value)
{
    storage.set(web_user,value)
    return value;
}
//获取用户信息
export function getLocalUser()
{
    return storage.get(web_user,null);
}
export function removeLocalUser(){
    storage.remove(web_user);
}

//修改token
export function setToken(token)
{
    localStorage.setItem(web_token,token);
}

//获取token
export function getToken()
{
    return localStorage.getItem(web_token);
}
//移除token
export function removeToken(){

    localStorage.removeItem(web_token);
}